var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "1.2 2 21.333333 21.333333",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 21,10.5 V 8 C 21,6.89543 20.1046,6 19,6 H 5 C 3.89543,6 3,6.89543 3,8 v 9 c 0,1.1046 0.89543,2 2,2 h 7",
    stroke: "url(#paint0_linear_1855_33831)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m 15,16.4286 c 0,-0.4734 0.3838,-0.8572 0.8571,-0.8572 h 4.2858 c 0.4733,0 0.8571,0.3838 0.8571,0.8572 v 2.7143 C 21,19.6162 20.6162,20 20.1429,20 H 15.8571 C 15.3838,20 15,19.6162 15,19.1429 Z",
    stroke: "url(#paint0_linear_1855_33831)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 16.7143,14.2857 C 16.7143,13.5756 17.2899,13 18,13 c 0.7101,0 1.2857,0.5756 1.2857,1.2857 v 1.2857 h -2.5714 z",
    stroke: "url(#paint0_linear_1855_33831)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 3,10 H 20.5",
    stroke: "url(#paint0_linear_1855_33831)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M 7,15 H 9",
    stroke: "url(#paint0_linear_1855_33831)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1855_33831",
    x1: 16.2535,
    y1: 42.5184,
    x2: 45.3643,
    y2: 33.2162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1855_33831",
    x1: 35.0675,
    y1: 45.2661,
    x2: 41.7661,
    y2: 42.4764,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeLock);
export default __webpack_public_path__ + "static/media/home-lock.26f3371f99e2dd9fd0e49676a0ff8f47.svg";
export { ForwardRef as ReactComponent };